import upsell from "../upsell"
import primer from "../primer"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("basic_annual"),
  ...primer(),

  onInit() {
    this.initUpsell()
    this.initPrimer({
      checkoutCompletePath: this.getThankYouPath(),
    })
  },
})
